import {
  Component, Output, EventEmitter
} from '@angular/core';
import { formService } from '../Service/formService';
import { each as _each, cloneDeep } from 'lodash-es'
import { ePayService } from "../Service/ePayService";
import { Session_CardModel } from '../Models/Model/Session_CardModel';
import { ApplePaymentRequest } from '../Service/ApplePay';
import { Session_AppleDetailsModel } from '../Models/Model/Session_AppleDetailsModel';
import { Session_AppleAddressModel } from '../Models/Model/Session_AppleAddressModel';
import { Session_AppleSubmissionModel } from '../Models/Model/Session_AppleSubmissionModel';
import { Token } from '../Models/Token';
import { cardConnectService } from '../Service/cardConnectService';
import { HttpClient } from '@angular/common/http';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';
import ca from 'date-fns/locale/ca';

declare var ApplePaySession: any;

@Component({
  selector: 'apple-pay',
  templateUrl: 'applepay.component.html',
  styleUrls: ['applepay.component.css'],
  providers: [],
  exportAs: 'ngModel'
})
export class ApplePayComponent {
  public canMakePayment: boolean = false;
  private applePaymentRequest: ApplePaymentRequest | null | undefined;
  private CardConnectService: cardConnectService;

  @Output() makePayment = new EventEmitter<any>();

  //Determines if apple can be done in browser
  public canDoApplePay = () => {
    try {
      if ((<any>window).ApplePaySession) {
        if (this.EPayService.ePay) {
          _each(this.EPayService.ePay.xmlPayment.creditCards.cards, (cardModel: Session_CardModel) => {
            console.info('cardModel', cardModel);
            if (cardModel.cardId === "APLE") {
              console.info('ApplePaySession', ApplePaySession);
              if (ApplePaySession) {
                console.info('ApplePaySession.canMakePayments()', ApplePaySession.canMakePayments());
                if (ApplePaySession.canMakePayments()) {
                  this.canMakePayment = true;
                }
              }
            }
          }
          );
        }
      }
    }
    catch (ex) {
      this.canMakePayment = false;
    }
  }

  get EPayService(): ePayService {
    return this.FormService.EPayService;
  }

  constructor(
    private FormService: formService, private httpClient: HttpClient) {
    this.CardConnectService = new cardConnectService(httpClient);
  }

  ngOnInit() {
    this.canDoApplePay();
  }

  methods: Array<ApplePaymentMethodData> = [];
  method: ApplePaymentMethodData | null | undefined = null;
  details: ApplePaymentDetailsInit | null | undefined = null;
  options: ApplePaymentOptions | null | undefined = null;

  //init apple pay
  applePay = () => {
    if (this.EPayService?.ePay?.paymentPage.totalAmount) {
      console.info('going to do apple pay');

      var request: ApplePaymentRequest | null = null;

      this.methods = [];
      this.method = new ApplePaymentMethodData();
      this.details = new ApplePaymentDetailsInit();
      this.options = new ApplePaymentOptions();

      this.method.supportedMethods = "https://apple.com/apple-pay";
      this.method.data = {
        version: 2,
        merchantIdentifier: this.EPayService.ePay?.paymentPage.merchantIdentifier,
        merchantCapabilities: ["supports3DS", "supportsCredit", "supportsDebit"],
        supportedNetworks: this.allowedCardTypes(),
        countryCode: "US",
        validationEndpoint: 'api/apple/processapple'
      }
      this.methods.push(this.method);

      console.info('methods', this.methods);

      this.details.total = new ApplePaymentItem();
      this.details.total.amount = new ApplePaymentCurrencyAmount();

      this.details.total.amount.value = this.EPayService.ePay.paymentPage.totalAmount.toString();
      this.details.total.amount.currency = "USD";
      this.details.total.label = "";

      this.options.requestPayerEmail = false;
      this.options.requestPayerName = false;
      this.options.requestPayerPhone = false;
      this.options.requestShipping = false;

      console.info('ready to make object', this.methods, this.details, this.options);
      request = new ApplePaymentRequest(this.methods, this.details, this.options);
      console.info('made object', request);

      if (request != null) {
        // @ts-ignore
        request.onpaymentmethodchange = event => {
          event.updateWith({});
        };

        // @ts-ignore
        request.onshippingaddresschange = event => {
          event.updateWith({});
        };

        //validate merchant account
        request.onvalidatemerchant = (event: any) => {
          console.info('onvalidatemerchant', event);
          this.FormService.postApplePay(event.validationURL).subscribe((result) => {
            console.info("result", result);
            if (request != null) {

              var apple = {
                "epochTimestamp": result.paymentPage.apple?.epochTimestamp,
                "expiresAt": result.paymentPage.apple?.expiresAt,
                "merchantSessionIdentifier": result.paymentPage.apple?.merchantSessionIdentifier,
                "nonce": result.paymentPage.apple?.nonce,
                "merchantIdentifier": result.paymentPage.apple?.merchantIdentifier,
                "domainName": result.paymentPage.apple?.domainName,
                "displayName": result.paymentPage.apple?.displayName,
                "signature": result.paymentPage.apple?.signature
              };
              console.info("result.paymentPage.apple", result.paymentPage.apple);
              console.info("apple", apple);
              request.completeMerchantValidation(
                apple
              );
            }
          })
        }

        //when apple pay is selected
        request.onpaymentmethodselected = (event: any) => {
          if (this.EPayService?.ePay?.paymentPage.totalAmount && request) {
            let lineItem: ApplePayJS.ApplePayLineItem = {
              amount: this.EPayService.ePay.paymentPage.totalAmount.toString(),
              label: "",
              type: "final"
            };
            console.info('lineItem', lineItem);
            console.info('totalAmount', this.EPayService.ePay.paymentPage);
            console.info('onpaymentmethodselected', event);
            request.completePaymentMethodSelection(lineItem, []);
          }
        }

        //send apple pay to the processor
        request.show().then((result: any) => {
          let _result = new ApplePaymentResponse();
          console.log('show', result);
          if (
            this.EPayService.ePay?.paymentPage.appleSubmission
            //this.EPayService.ePay?.paymentPage.cardData &&
            //this.EPayService.ePay.paymentPage.appleSubmission?.applePayRaw.token.paymentData.header
            )
          {
            console.info('show result', result);

            this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw = result.applePayRaw.applePayRaw;
            this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token = result.applePayRaw.applePayRaw.token;
            this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token.paymentData = result.applePayRaw.applePayRaw.token.paymentData;
            this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token.paymentData.header = result.applePayRaw.applePayRaw.token.paymentData.header;
            this.EPayService.ePay.paymentPage.appleSubmission.details = <Session_AppleDetailsModel>result.details;
            this.EPayService.ePay.paymentPage.appleSubmission.methodName = result.methodName;
            this.EPayService.ePay.paymentPage.appleSubmission.payerEmail = result.payerEmail;
            this.EPayService.ePay.paymentPage.appleSubmission.payerName = result.payerName;
            this.EPayService.ePay.paymentPage.appleSubmission.payerPhone = result.payerPhone;
            this.EPayService.ePay.paymentPage.appleSubmission.shippingAddress = <Session_AppleAddressModel>result.shippingAddress;
            this.EPayService.ePay.paymentPage.appleSubmissionText = JSON.stringify(result);
            var devicedata = result.applePayRaw.applePayRaw.token.paymentData.data;
            devicedata = devicedata + "&ectype=apple";
            devicedata = devicedata + "&ecsig=" + this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token.paymentData.signature;
            devicedata = devicedata + "&eckey=" + this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token.paymentData.header?.ephemeralPublicKey;
            devicedata = devicedata + "&ectid=" + this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token.paymentData.header?.transactionId;
            devicedata = devicedata + "&echash="; // + this.EPayService.ePay.paymentPage.appleSubmission.applePayRaw.token.paymentData.;
            //Post to card connect to get the token
            //console.info('devicedata:' + devicedata);
            console.info(
              JSON.stringify(
                {
                  "encryptionhandler": "EC_APPLE_PAY",
                  "devicedata": devicedata
                }));

            this.CardConnectService.postApple(this.EPayService.Origin(), devicedata).subscribe((data: any) => {
              console.info('from card connect', data);
              if (this.EPayService.ePay?.paymentPage.cardData && this.EPayService.ePay.paymentPage.credit_card) {
                this.EPayService.ePay.paymentPage.cardData.expiry = "";
                this.EPayService.ePay.paymentPage.cardData.fullName = this.EPayService.ePay.paymentPage.cardHolderName;
                this.EPayService.ePay.paymentPage.cardData.token = data.token;
                _each(this.EPayService.ePay.paymentPage.credit_card, (req: Session_Credit_Card_RequestModel) => {
                  req.response.token = data.token;
                });

                this.makePayment.emit(result);
                //this.FormService.PerformPayment(this.EPayService.ePay.paymentPage.credit_card).subscribe((data) => {
                //  if (this.EPayService.ePay) {
                //    if (this.EPayService.ePay.iotp.processState === 'CompletedOk') {
                //      result.complete('success');
                //    }
                //  }
                //  result.complete('fail');
                //});
              }
            })
          }
        }, (error) => {
          console.info('error', error);
        }
        )
      }
    }
  }

  //Get the allowed card types for apple pay
  private allowedCardTypes = () => {
    let brands: string[] = [];

    if (this.FormService.EPayService.ePay) {
      _each(this.FormService.EPayService.ePay.xmlPayment.creditCards.cards, (card: Session_CardModel) => {
        console.info('card', card);
        if (card.cardId === "VISA") {
          brands.push('visa');
        }
        if (card.cardId === "MAST") {
          brands.push('masterCard');
        }
        if (card.cardId === "DISC") {
          brands.push('discover');
        }
        if (card.cardId === "AMER") {
          brands.push('amex');
        }
        if (card.cardId === "JCB") {
          brands.push('jcb');
        }
        if (card.cardId === "UNIONPAY") {
          brands.push('chinaUnionPay');
        }
      });
    }
    return brands;
  }
}

//Additional properties of apple pay
export class ApplePaymentMethodData implements PaymentMethodData {
  data?: any;
  supportedMethods: string = '';// | string[];
}

//Additional properties of apple pay
export class ApplePaymentDetailsInit implements PaymentDetailsInit {
  id?: string;
  total: ApplePaymentItem = {
    amount: new ApplePaymentCurrencyAmount(),
    label: ''
  };
  displayItems?: ApplePaymentItem[];
  modifiers?: ApplePaymentDetailsModifier[];
  shippingOptions?: ApplePaymentShippingOption[];
}

//Additional properties of apple pay
export class ApplePaymentItem implements PaymentItem {
  amount: ApplePaymentCurrencyAmount = {
    currency: '',
    value: '',
    currencySystem: ''
  };
  label: string = '';
  pending?: boolean;
}

//Additional properties of apple pay
export class ApplePaymentCurrencyAmount implements PaymentCurrencyAmount {
  currency: string ='';
  currencySystem?: string ='';
  value: string ='';
}

//Additional properties of apple pay
export class ApplePaymentDetailsModifier implements PaymentDetailsModifier {
  additionalDisplayItems?: ApplePaymentItem[]; data?: any;
  supportedMethods: string = '';// | string[];
  total?: ApplePaymentItem;
}

//Additional properties of apple pay
export class ApplePaymentShippingOption implements PaymentShippingOption {
  amount: ApplePaymentCurrencyAmount = {
    currency: '',
    value: '',
    currencySystem: ''
  };
  id: string = '';
  label: string = '';
  selected?: boolean;
}

//Additional properties of apple pay
export class ApplePaymentOptions implements PaymentOptions {
  requestPayerEmail?: boolean;
  requestPayerName?: boolean;
  requestPayerPhone?: boolean;
  requestShipping?: boolean;
  shippingType?: any;
}

//Additional properties of apple pay
export class ApplePaymentApplePayLineItem implements ApplePayJS.ApplePayLineItem {
  label: string ='';
  amount: string = '';
  type?: ApplePayJS.ApplePayLineItemType;
}

//Additional properties of apple pay
export class ApplePaymentResponse {
  details: any;
  methodName: string = '';
  payerEmail: string = '';
  payerName: string = '';
  payerPhone: string = '';
  requestId: string = '';
  shippingAddress: PaymentAddress = {
    dependentLocality: '',
    country: '',
    addressLine: [],
    city: '',
    organization: '',
    phone: '',
    postalCode: '',
    region: '',
    sortingCode: '',
    recipient: '',
    toJSON: function (): any { return null; }
  };
  shippingOption: string = '';
  applePayRaw: any;
}
